import type { FC, useEffect } from "react"
import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import { useTheme } from "@mui/material/styles"
import {
  Box,
  Step,
  Stepper,
  IconButton,
  Button,
  ButtonGroup,
  Typography,
  Stack,
} from "../../../components/mui.components"
import { Warning, Info } from "@mui/icons-material"
import { useAppDispatch, useAppSelector } from "@/core/app/hooks"
import { RootState } from "@/core/app/store"
import { ReactSVG } from "react-svg"

import CloseSvg from "../../assets/modeltools/RedXMark.svg"
import ResetSvg from "../../assets/bottomToolBar/stage/reset.svg"

import { resegmentationModule } from "@/gluelayer/core/modules/resegmentation/resegmentationModule"

interface Type {
  ClickManual?: (isManual) => void
  ClickReset?: () => void
  ClickClose?: (e) => void
  DoShowClose?: boolean
}

const RelabelTools: FC<Type> = ({
  ClickManual,
  ClickReset,
  ClickClose,
  DoShowClose,
}) => {
  const dispatch = useAppDispatch()
  const theme = useTheme()

  const [isManualSelected, setManualSelected] = useState<boolean | null>(false)

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-end",
          position: "absolute",
          top: "250px",
          right: "1%",
          width: "130px",
          height: "500px",
          borderRadius: 2,
          flexDirection: "column",

          //bgcolor: theme.transBkColor.light
        }}
      >
        <Box
          sx={{
            display: "flex",
            right: "2%",
            width: "250px",
            height: "70px",
            borderRadius: 2,
            flexDirection: "row-reverse",
            alignItems: "center",
            //bgcolor: theme.transBkColor.light
          }}
        >
          {DoShowClose && (
            <Box
              sx={{
                display: "flex",
                alignItems: "column",
                width: "35px",
                height: "35px",
                marginLeft: "20px",
              }}
            >
              <IconButton
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "35px",
                  height: "35px",
                  borderRadius: 100,
                  backgroundColor: "#FF632B",
                  "&:hover": { background: "#FF632B" },
                }}
                onClick={ClickClose}
              >
                <img
                  src={CloseSvg}
                  style={{ height: "18px", width: "18px" }}
                ></img>
              </IconButton>
            </Box>
          )}

          <Typography variant="h5" color="#FFFFFF">
            Check Label
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            marginTop: "15px",
            width: "65px",
            height: "261px",
            // borderRadius: 2,
            flexDirection: "column",
            marginRight: "5px",
            // gap: "1px",
            // paddingTop: "15px",
            // backgroundColor: theme.transBkColor.light,
          }}
        >
          <Button
              sx={{
                  height: "65px",
                  width: "65px",
                  textTransform: "none",
                  padding: "0px 0px",
                  flexWrap: "wrap",
                  border: "none",
                  borderRadius: "0px",
                  background: isManualSelected ? "#00ADEF" : "#f9f9f9",
                      "&:hover": {
                      background: isManualSelected ? "#00ADEF" : "#f9f9f9",
                  },
                  borderBottom: "1px solid",
                  borderColor: "rgba(59 / 255, 66 / 255,  71 / 255 )",
                  }}
              onClick={(e) => {
                if(ClickManual)ClickManual(!isManualSelected)
                setManualSelected(!isManualSelected)
              }}
          >
            <Typography
              fontSize="14px"
              fontWeight="600"
              fontFamily="Roboto"
              fontStyle="normal"
              color="#444444"
              letterSpacing="0.1px"
            >
              Manual
            </Typography>
          </Button>


          <Button
              sx={{
                  height: "65px",
                  width: "65px",
                  textTransform: "none",
                  padding: "0px 0px",
                  flexWrap: "wrap",
                  border: "none",
                  borderRadius: "0px",
                  backgroundColor: "#f9f9f9",
                      "&:hover": {
                        backgroundColor: "#f9f9f9",
                      },
                      borderBottom: "1px solid",
                      borderColor: "rgba(59 / 255, 66 / 255,  71 / 255 )",
                  }}
              onClick={(e) => {
                ClickReset()
              }}
          >
            <Typography
              fontSize="14px"
              fontWeight="600"
              fontFamily="Roboto"
              fontStyle="normal"
              color="#444444"
              letterSpacing="0.1px"
            >
              Reset
            </Typography>
          </Button>


        </Box>
        
      </Box>
    </>
  )
}
export default RelabelTools
